import { ReactNode } from 'react';
import Card from 'react-bootstrap/Card';
import logo from '../assets/logo.png';

export function AuthCard({ titulo, children }: { titulo: string; children: ReactNode }) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        background: 'var(--cor-fundo)',
      }}
    >
      <Card style={{ width: '100%', maxWidth: '380px', border: 'none', boxShadow: 'var(--sombra-elevada)', borderRadius: '16px' }}>
        <Card.Body className="p-4">
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
            <img src={logo} alt="Lizzi Food" width={56} height={56} />
          </div>
          <h1 style={{ fontSize: '20px', textAlign: 'center', marginBottom: '24px' }}>{titulo}</h1>
          {children}
        </Card.Body>
      </Card>
    </div>
  );
}
